import sendReportRequest from './sendReportRequest';

const fetchReportSalesOverview = async ({ dateRange, from, to, unit, reportingType }) => {
  const reponseData = await sendReportRequest({
    url: '/reports/salesOverview',
    dateRange,
    from,
    to,
    unit,
    reportingType,
  });

  return reponseData;
};

export default fetchReportSalesOverview;
